import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { format, parseJSON } from 'date-fns';

@Pipe({
  name: 'newsDescriptionPipe',
  pure: false,
})
export class NewsDescriptionPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    description: string,
    args: { caseStatus: string; replace: string[]; formatDate: string }
  ): string {
    let replaceDesc = '';
    switch (args.caseStatus) {
      case '30':
        replaceDesc = this.translateService.instant('News.Description.30');
        break;
      case '20':
        replaceDesc = this.translateService.instant('News.Description.20');
        break;
      case '40':
        replaceDesc = this.translateService.instant('News.Description.40');
        break;
      case '50':
        replaceDesc = this.translateService.instant('News.Description.50');
        break;
      case '170':
        replaceDesc = this.translateService.instant('News.Description.170');
        break;
      case '70':
        args.replace.forEach((value, index) => {
          if (index === 1) {
            description = description
              .replace(
                '{2}',
                this.translateService.instant('News.Description.70.2')
              )
              .replace(
                '{3}',
                format(parseJSON(new Date(value)), args.formatDate)
              );
          } else {
            description = description
              .replace(
                '{0}',
                this.translateService.instant('News.Description.70.1')
              )
              .replace(
                '{1}',
                format(parseJSON(new Date(value)), args.formatDate)
              );
          }
        });
        return description;
      case '190':
        replaceDesc = this.translateService.instant('News.Description.190');
        break;
      case '210':
        replaceDesc = this.translateService.instant('News.Description.210');
        break;
      // 下載合約
      case '-1':
        args.replace.forEach((value, index) => {
          if (index === 1) {
            description = description
              .replace(
                '{2}',
                this.translateService.instant('News.Description.-1.2')
              )
              .replace(
                '{3}',
                format(parseJSON(new Date(value)), args.formatDate)
              );
          } else {
            description = description
              .replace(
                '{0}',
                this.translateService.instant('News.Description.-1.1')
              )
              .replace(
                '{1}',
                format(parseJSON(new Date(value)), args.formatDate)
              );
          }
        });
        return description;
      // 下載設定文件
      case '-2':
        replaceDesc = this.translateService.instant('News.Description.-2');
        break;
      // 保險專區 - 報價完成
      case '-3':
        replaceDesc = this.translateService.instant('News.Description.-3');
        break;
      // 保險專區 - 投保完成
      case '-4':
        replaceDesc = this.translateService.instant('News.Description.-4');
        break;
      // 最新消息 - 預覽合約
      case '-5':
        replaceDesc = this.translateService.instant('News.Description.-5');
        break;    
      default:
        return '';
    }

    return description
      .replace('{0}', replaceDesc)
      .replace(
        '{1}',
        format(parseJSON(new Date(args.replace[0])), args.formatDate)
      );
  }
}
